import { TAG_CODES } from "../../tag.config"

const GOM_DATA_GEO_SLOPE_GRADIENT = {
    type: 'path',
    tagCode: TAG_CODES.DATA,
    withText: true,
    defaultText: 'Slope',
    positionText: 'top', // top - right - center - bottom - left
    fieldsText: ["title"],
    endTextWidthStr: "",
    angle: 0,
    colorCodeId: 'default',
    withFillColor: false,
    schema: {
        "type": 'object',
        "properties": {
            "title": {
                "title": "Text",
                "description": "Write a text",
                "type": "string",
            },
        },
        "required": []
    },
    pathData: `M19 73 19 8M28 15 19 3 11 15M6 58 34 58M6 68 34 68Z`,
}

export default GOM_DATA_GEO_SLOPE_GRADIENT